import styled from 'styled-components';
import { layer } from 'view/styles/z-index';

// eslint-disable-next-line rulesdir/no-styled-export
export const HighlighterButtonContainer = styled.div`
    background: transparent;
    border: 0;
    cursor: pointer;
    z-index: ${layer};
`;
